import React from 'react';

const LegacyDownloadView: React.FC = () => {
  return (
    <div className="container-fluid py-3">
      <div className="responsive-page-header mb-4">
        <h3 className="mb-1">Legacy Firmware Download</h3>
        <p className="text-muted mb-0">Download the original Run 1 Fluora Floor firmware image.</p>
      </div>

      <div className="alert alert-warning mb-4">
        <strong>Note:</strong> This firmware is provided for the original Run 1 of the Fluora Floor Plant only.
        New devices should use the current firmware update flow.
      </div>

      <div className="row g-4">
        <div className="col-lg-5 col-xl-4">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white">
              <h5 className="mb-0">Download Legacy Firmware</h5>
            </div>
            <div className="card-body p-4">
              <p className="text-muted">
                This ZIP contains the legacy disk image used for the original Fluora Floor hardware.
              </p>
              <a
                href="https://firmware.fluoraplant.com/downloads/legacy-firmware-image.zip"
                className="btn btn-primary btn-lg"
              >
                Download Legacy Firmware
              </a>
            </div>
          </div>
        </div>

        <div className="col-lg-7 col-xl-8">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white">
              <h5 className="mb-0">Installation Instructions</h5>
            </div>
            <div className="card-body">
              <div className="flasher-instructions-list">
                <div className="flasher-instruction-step">
                  <span className="flasher-step-number">1</span>
                  <span className="flasher-instruction-text">Download the legacy firmware ZIP file</span>
                </div>
                <div className="flasher-instruction-step">
                  <span className="flasher-step-number">2</span>
                  <span className="flasher-instruction-text">Extract the ZIP file to access the disk image file</span>
                </div>
                <div className="flasher-instruction-step">
                  <span className="flasher-step-number">3</span>
                  <span className="flasher-instruction-text">
                    Download and install <a href="https://www.balena.io/etcher/" target="_blank" rel="noopener noreferrer">Balena Etcher</a>
                  </span>
                </div>
                <div className="flasher-instruction-step">
                  <span className="flasher-step-number">4</span>
                  <span className="flasher-instruction-text">Insert your SD card into your computer</span>
                </div>
                <div className="flasher-instruction-step">
                  <span className="flasher-step-number">5</span>
                  <span className="flasher-instruction-text">In Balena Etcher, choose the image file and select your SD card as the target</span>
                </div>
                <div className="flasher-instruction-step">
                  <span className="flasher-step-number">6</span>
                  <span className="flasher-instruction-text">Flash the image, then safely eject the SD card</span>
                </div>
                <div className="flasher-instruction-step">
                  <span className="flasher-step-number">7</span>
                  <span className="flasher-instruction-text">Insert the SD card into your Fluora device and power it on</span>
                </div>
              </div>
              <div className="alert alert-danger mb-0">
                Flashing the image will erase all data on the selected SD card.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegacyDownloadView;
